module.exports = __webpack_public_path__ + "static/media/tadoo.b6ed18f2.png";